angular.module('env.data.rest.model.validationTemplates', [])

    .constant('FieldValidationTemplates', {
        /**
         * Value is not null or undefined or NaN
         */
        notNull: function () {
            return [
                function (val) {
                    return !(_.isNull(val) || _.isUndefined(val) || _.isNaN(val));
                },
                "Value must be set"
            ];
        },

        /**
         * Value is not null or undefined or NaN or empty
         */
        notEmpty: function () {
            return [
                function (val) {
                    return !(_.isNull(val) || _.isUndefined(val) || _.isNaN(val) || val == '' || (_.isArray(val) && val.length <= 0));
                },
                "Value must be set"
            ];
        },

        /**
         * Value length is between two arguments. For every entity that has toString method
         * @param {Integer|Number} longerThan
         * @param {Integer|Number} shorterThan
         */
        lenBetween: function (longerThan, shorterThan) {
            return [
                function (val) {
                    if (_.isNull(val) || _.isUndefined(val) || _.isNaN(val)) {
                        return false;
                    }
                    if (val.toString) {
                        var strVal = val.toString();
                        return (longerThan ? strVal.length >= longerThan : true) &&
                            (shorterThan ? strVal.length <= shorterThan : true);
                    }

                    throw new Error("Not implemented");
                },
                "Value length must be between %s and %s",
                longerThan.toString(),
                shorterThan.toString()
            ];
        },

        /**
         * Value length is longer than argument. For every entity that has toString method
         * @param {Integer|Number} longerThan
         */
        longer: function (longerThan) {
            return [
                function (val) {
                    if (_.isNull(val) || _.isUndefined(val) || _.isNaN(val)) {
                        return false;
                    }
                    if (val.toString) {
                        var strVal = val.toString();
                        return longerThan ? strVal.length >= longerThan : true;
                    }

                    throw new Error("Not implemented");
                },
                "Value length must be longer than %s",
                longerThan.toString()
            ];
        },

        /**
         * Value length is shorter than argument. For every entity that has toString method
         * @param {Integer|Number} shorterThan
         */
        shorter: function (shorterThan) {
            return [
                function (val) {
                    if (_.isNull(val) || _.isUndefined(val) || _.isNaN(val)) {
                        return false;
                    }
                    if (val.toString) {
                        var strVal = val.toString();
                        return shorterThan ? strVal.length <= shorterThan : true;
                    }

                    throw new Error("Not implemented");
                },
                "Value length must be shorter than %s",
                shorterThan.toString()
            ];
        },

        /**
         * Value is between two arguments. For numbers and dates only
         * @param {Integer|Number|Date} greaterThan
         * @param {Integer|Number|Date} lessThan
         */
        between: function (greaterThan, lessThan) {
            return [
                function (val, fieldDefinition) {
                    if (_.isNull(val) || _.isUndefined(val) || _.isNaN(val)) {
                        return false;
                    }
                    if (fieldDefinition.type == 'integer' || fieldDefinition.type == 'number' || fieldDefinition.type == 'date') {
                        return (greaterThan ? val >= greaterThan : true) && (lessThan ? val <= lessThan : true);
                    }

                    throw new Error("Not implemented");
                },
                "Value must be between %s and %s",
                greaterThan.toString(),
                lessThan.toString()
            ];
        },

        /**
         * Value is greater than argument. For numbers and dates only
         * @param {Integer|Number|Date} greaterThan
         */
        greater: function (greaterThan) {
            return [
                function (val, fieldDefinition) {
                    if (_.isNull(val) || _.isUndefined(val) || _.isNaN(val)) {
                        return false;
                    }
                    if (fieldDefinition.type == 'integer' || fieldDefinition.type == 'number' || fieldDefinition.type == 'date') {
                        return (greaterThan ? val > greaterThan : true);
                    }
                    throw new Error("Not implemented");
                },
                "Value must be greater than %s",
                greaterThan.toString()
            ]
        },

        /**
         * Value is greater or equal than argument. For numbers and dates only
         * @param {Integer|Number|Date} greaterOrEqualThan
         */
        greaterOrEqual: function (greaterOrEqualThan) {
            return [
                function (val, fieldDefinition) {
                    if (_.isNull(val) || _.isUndefined(val) || _.isNaN(val)) {
                        return false;
                    }
                    if (fieldDefinition.type == 'integer' || fieldDefinition.type == 'number' || fieldDefinition.type == 'date') {
                        return greaterOrEqualThan ? val >= greaterOrEqualThan : true;
                    }

                    throw new Error("Not implemented");
                },
                "Value must be greater or equal than %s",
                greaterOrEqualThan.toString()
            ]
        },

        /**
         * Value is less than argument. For numbers and dates only
         * @param {Integer|Number|Date} lessThan
         */
        less: function (lessThan) {
            return [
                function (val, fieldDefinition) {
                    if (_.isNull(val) || _.isUndefined(val) || _.isNaN(val)) {
                        return false;
                    }
                    if (fieldDefinition.type == 'integer' || fieldDefinition.type == 'number' || fieldDefinition.type == 'date') {
                        return lessThan ? val < lessThan : true;
                    }

                    throw new Error("Not implemented");
                },
                "Value must be less than %s",
                lessThan.toString()
            ]
        },

        /**
         * Value is less or equal than argument. For numbers and dates only
         * @param {Integer|Number|Date} lessOrEqualThan
         */
        lessOrEqual: function (lessOrEqualThan) {
            return [
                function (val, fieldDefinition) {
                    if (_.isNull(val) || _.isUndefined(val) || _.isNaN(val)) {
                        return false;
                    }
                    if (fieldDefinition.type == 'integer' || fieldDefinition.type == 'number' || fieldDefinition.type == 'date') {
                        return (lessOrEqualThan ? val <= lessOrEqualThan : true);
                    }

                    throw new Error("Not implemented");
                },
                "Value must be less or equal than %s",
                lessOrEqualThan.toString()
            ]
        },

        /**
         * Value is positive (greater than zero)
         */
        isPositive: function () {
            return [
                function (val, fieldDefinition) {
                    if (_.isNull(val) || _.isUndefined(val) || _.isNaN(val)) {
                        return false;
                    }
                    if (fieldDefinition.type == 'integer' || fieldDefinition.type == 'number') {
                        return val > 0;
                    }

                    throw new Error("Not implemented");
                },
                "Value must be positive"
            ]
        },

        /**
         * Value is positive or equal to zero
         */
        isPositiveOrZero: function () {
            return [
                function (val, fieldDefinition) {
                    if (_.isNull(val) || _.isUndefined(val) || _.isNaN(val)) {
                        return false;
                    }
                    if (fieldDefinition.type == 'integer' || fieldDefinition.type == 'number') {
                        return val >= 0;
                    }

                    throw new Error("Not implemented");
                },
                "Value must be positive or equal to zero"
            ]
        },

        /**
         * Value is negative (greater than zero)
         */
        isNegative: function () {
            return [
                function (val, fieldDefinition) {
                    if (_.isNull(val) || _.isUndefined(val) || _.isNaN(val)) {
                        return false;
                    }
                    if (fieldDefinition.type == 'integer' || fieldDefinition.type == 'number') {
                        return val < 0;
                    }

                    throw new Error("Not implemented");
                },
                "Value must be negative"
            ]
        },

        /**
         * Value is positive or equal to zero
         */
        isNegativeOrZero: function () {
            return [
                function (val, fieldDefinition) {
                    if (_.isNull(val) || _.isUndefined(val) || _.isNaN(val)) {
                        return false;
                    }
                    if (fieldDefinition.type == 'integer' || fieldDefinition.type == 'number') {
                        return val <= 0;
                    }

                    throw new Error("Not implemented");
                },
                "Value must be negative or equal to zero"
            ]
        }
    })

;